module.exports = __webpack_public_path__ + "static/img/312_TO8_2304.7b74877.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/312_TO8_2304.jpg
// module id = GyUN
// module chunks = 0